import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('Container')(() => css({
    mt: 'm',
    pt: '16px',
    borderTop: '1px solid',
    borderTopColor: 'grey.3',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: ['column', 'column', 'row'],
    gap: 'm',
}));
themeStyles.addBaseStyles('CheckboxesContainer')(() => css({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
}));
themeStyles.addBaseStyles('PriceBreakdownLink')(() => css({
    whiteSpace: 'nowrap',
    width: 'min-content',
}));
export default themeStyles;
